import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27e670ce")

_pushScopeId("data-v-27e670ce")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("ジャーナルを編集")
const _hoisted_2 = {
  key: 0,
  class: "w-3/4 p-3 mx-auto mb-6 flex items-center bg-red-100 rounded-md"
}
const _hoisted_3 = { class: "text-red-500" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "ml-2 font-medium text-sm text-gray-700" }, " このジャーナルは下書き状態です。公開するには入力ウィンドウ右下の「公開する」ボタンを押してください ", -1)
const _hoisted_5 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_6 = { class: "w-3/4 mx-auto mb-6 z-auto" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm font-medium text-gray-500" }, " 振り返り項目 ", -1)
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = {
  key: 1,
  class: "text-xs text-gray-400"
}
const _hoisted_10 = { class: "mt-4 flex justify-center" }
const _hoisted_11 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_12 = {
  key: 0,
  class: "leading-7 text-sm font-medium mb-4 text-red-500"
}
const _hoisted_13 = {
  key: 1,
  class: "leading-7 text-sm font-medium mb-4 text-red-400"
}
const _hoisted_14 = { class: "p-4 flex items-center gap-2 bg-primary-100 rounded-md" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  for: "include-chat-in-prompt",
  class: "leading-7 text-sm font-medium text-gray-600 cursor-pointer"
}, " プロンプトに生徒のAIとのやり取りデータを含める ", -1)
const _hoisted_16 = {
  key: 0,
  class: "leading-7 text-sm font-medium mb-4 text-red-400"
}
const _hoisted_17 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  class: "pr-4 mt-4 text-sm text-gray-600"
}
const _hoisted_20 = { class: "flex gap-4" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 完了にする ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 完了を解除 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 公開する ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_text_area = _resolveComponent("m-text-area")
  const _component_ms_student_picker = _resolveComponent("ms-student-picker")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      (_ctx.journal.isDraft)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_m_icon, {
                type: "warning",
                size: "6"
              })
            ]),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_m_text_field, {
          label: "ジャーナルの名称",
          name: "title",
          type: "text",
          value: _ctx.title,
          placeholder: "ジャーナルの名称を入力してください",
          invalid: !_ctx.validTitle,
          "invalid-message": "ジャーナルの名称は1文字以上入力してください",
          entered: _ctx.titleEntered,
          onEnter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.titleEntered = true)),
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.title = $event))
        }, null, 8, ["value", "invalid", "entered"])
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reflectionItems, (item, i) => {
            return (_openBlock(), _createBlock("div", {
              key: item.uid,
              class: "relative flex flex-col gap-2 bg-gray-50 rounded-md px-2 py-4"
            }, [
              (_ctx.reflectionItems.length > 1)
                ? (_openBlock(), _createBlock(_component_m_icon, {
                    key: 0,
                    type: "close",
                    size: "6",
                    class: "absolute top-1 right-1 cursor-pointer text-gray-500",
                    onClick: ($event: any) => (_ctx.removeReflectionItem(i))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_m_text_field, {
                label: "項目のタイトル",
                name: "input-title",
                type: "text",
                value: item.title,
                placeholder: "項目のタイトルを入力してください",
                onInput: ($event: any) => (_ctx.updateReflectionItemTitle($event, i))
              }, null, 8, ["value", "onInput"]),
              _createVNode(_component_m_select_box, {
                key: "value",
                label: "タイプ",
                name: "type-selection",
                placeholder: "タイプを選択",
                options: _ctx.reflectionTypes,
                value: item.type,
                "value-key": "value",
                "text-key": "label",
                disabled: _ctx.isReflectionItemTypeDisabled(item),
                onChange: ($event: any) => (_ctx.updateReflectionItemType($event, i))
              }, null, 8, ["options", "value", "disabled", "onChange"]),
              (_ctx.isReflectionItemTypeDisabled(item))
                ? (_openBlock(), _createBlock("p", _hoisted_9, " 編集できません "))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", {
            class: "w-1/12 flex justify-center text-gray-500 cursor-pointer",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addEmptyReflectionItem && _ctx.addEmptyReflectionItem(...args)))
          }, [
            _createVNode(_component_m_icon, {
              type: "plus",
              size: "6"
            })
          ])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_m_text_area, {
          label: "AIコメントを取得する際のプロンプト",
          name: "prompt",
          value: _ctx.prompt,
          placeholder: "プロンプトを入力してください",
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.prompt = $event)),
          onEnter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.promptEntered = true))
        }, null, 8, ["value"]),
        (_ctx.promptEntered && !_ctx.validPrompt)
          ? (_openBlock(), _createBlock("p", _hoisted_12, " ※ プロンプトの設定は必須です。 "))
          : _createCommentVNode("", true),
        (_ctx.prompt.length > 0)
          ? (_openBlock(), _createBlock("p", _hoisted_13, " ※ 設定したプロンプトの末尾にジャーナルの振り返り内容が挿入されます。 "))
          : _createCommentVNode("", true),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_14, [
            _withDirectives(_createVNode("input", {
              id: "include-chat-in-prompt",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.includeChatInPrompt = $event)),
              type: "checkbox",
              name: "include-chat-in-prompt",
              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, _ctx.includeChatInPrompt]
            ]),
            _hoisted_15
          ]),
          (_ctx.includeChatInPrompt)
            ? (_openBlock(), _createBlock("p", _hoisted_16, " ※ 10万文字を超える場合、切り捨てて送信されます。 "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        (!_ctx.availableToAllStudents)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              (!_ctx.allStudentsFetched)
                ? (_openBlock(), _createBlock("p", _hoisted_19, " 生徒情報読み込み中... "))
                : (_openBlock(), _createBlock(_component_ms_student_picker, {
                    key: 1,
                    "default-student-ids": _ctx.selectedStudentIds,
                    onUpdate: _ctx.updateSelectedStudents
                  }, null, 8, ["default-student-ids", "onUpdate"]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_20, [
        (!_ctx.journal.isDraft)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              (!_ctx.journal.isCompleted)
                ? (_openBlock(), _createBlock(_component_m_button, {
                    key: 0,
                    color: "secondary-500",
                    "hover-color": "secondary-600",
                    outline: "",
                    onClick: _ctx.markJournalAsCompleted
                  }, {
                    default: _withId(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_m_button, {
                    key: 1,
                    color: "secondary-500",
                    "hover-color": "secondary-600",
                    outline: "",
                    onClick: _ctx.markJournalAsInProgress
                  }, {
                    default: _withId(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.journal.publishedAt === null)
          ? (_openBlock(), _createBlock(_component_m_button, {
              key: 1,
              color: "primary-500",
              "hover-color": "primary-600",
              outline: "",
              disabled: !_ctx.validData,
              onClick: _ctx.publishJournal
            }, {
              default: _withId(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validData,
          onClick: _ctx.updateJournal
        }, {
          default: _withId(() => [
            _hoisted_25
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})